module.exports = __webpack_public_path__ + "img/hr-level1_running_gun.427476ba.png";